import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { format } from 'date-fns';
import { useReportsStore } from '../../../../../store/hooks';

const formatDeactivationDate = (dateString: string): string =>
  format(new Date(dateString), 'dd.MM.yyyy HH:mm');

export const DeactivationsTable = observer(() => {
  const reportsStore = useReportsStore();
  const deactivations = reportsStore.submissionsReport?.deactivations;

  if (deactivations === undefined) return null;

  if (deactivations.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Brak wyłączeń w wybranym okresie.
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table sx={{ minWidth: '650px', backgroundColor: 'white' }}>
        <TableHead>
          <TableRow>
            {['DATA OD', 'DATA DO', 'POWÓD WYŁĄCZENIA', 'DATA UTWORZENIA'].map((label) => (
              <TableCell
                key={label}
                sx={{ padding: '16px', textAlign: 'center', borderRight: '1px solid #E0E0E0' }}
              >
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {deactivations.map((item) => (
            <TableRow key={item.id}>
              <TableCell sx={{ textAlign: 'center' }}>
                {formatDeactivationDate(item.dateStart)}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {item.dateEnd ? formatDeactivationDate(item.dateEnd) : 'OBECNIE'}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>{item.reason}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {item.createdAt ? formatDeactivationDate(item.createdAt) : '—'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
